// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_6IG","cls2":"FeedbackPopover-cls2_5wz FeedbackPopover-cls1_6IG"};